<template>
  <base-card>
    <base-heading v-if="baseHeading">
      {{ title }}
    </base-heading>
    <tab-bar-chart
      :title="baseHeading ? '' : title"
      :chartdata="barChartData"
      :options="chartOptions"
      :height="options.height"
      :compose-labels="false"
      y-grid
      :label-size="responsiveLabelSize"
    />
  </base-card>
</template>
<script>
export default {
  name: 'OutReachEmailPerformance',
  props: {
    chartdata: {
      type: Array,
      default: () => ([]),
    },
    labels: {
      type: Array,
      default: () => ([]),
    },
    height: {
      type: Number,
      default: 300,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    baseHeading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      responsiveLabelSize: 13,
      barColor: '#E9AD7D6a',
      barThickness: 100,
      options: {
        height: this.height,
      },
    };
  },
  computed: {
    title() {
      return 'How your email compares';
    },
    barChartData() {
      const borderWidth = 0;
      const { barThickness } = this;

      const loadingColor = '#eeeeee';

      return {
        labels: this.labels,
        datasets: this.chartdata.map((metric) => ({
          backgroundColor: this.loading ? loadingColor : this.barColor,
          borderColor: '#00000000',
          borderWidth,
          barThickness,
          label: metric.name,
          data: metric.values.map((value) => (this.loading ? 50 : (100 * value))),
        })),
      };
    },
    chartOptions() {
      return {
        dataLabelsDisplay: !this.loading,
      };
    },
  },
  watch: {
    height: {
      handler(newVal) {
        this.options.height = newVal;
      },
      immediate: true,
    },
  },
  mounted() {
    this.mediaQuery();
  },
  methods: {
    mediaQuery() {
      /* This method mimics CSS mediaqueries but in JS.
      Required to pass variables to ChartJS */

      const mediaQuery = window.matchMedia('(min-width: 1000px)');
      const sizes = {
        small: 12, // This is an arbitrary size that fixes into ipad size
        regular: 15, // Defined by design team
      };
      const resize = (mq) => {
        this.responsiveLabelSize = (mq.matches) ? sizes.regular : sizes.small;
        this.barThickness = (mq.matches) ? 100 : 60;
      };
      resize(mediaQuery); // Initial call
      mediaQuery.addEventListener('change', (mq) => resize(mq)); // Listening to changes
    },
  },

};
</script>
<style lang="css" scoped>
</style>
